export enum ConfirmActivityAction {
    START,
    FINISH,
}